// @flow

import React                     from 'react';
import Company                   from './company';
import MaxLimitSends             from './maxLimitSends.js';

const Companies = (
  { currentApp, translate, selectedApp, _setSelectedApp, _createReminder, hasOutOfLimit } :
  { currentApp: Object, translate: any, selectedApp: Array<Number>, _setSelectedApp: Function, _createReminder: Function, hasOutOfLimit: any }) => {

  function getAvalibleItem() {
    return currentApp.app_companies.filter(item =>
      item.reminder_ws.enabled && item.reminder_ws.count < 2 && !item.reminder_ws.hidden
    );
  }

  return (
    <div className="reminder--body">
      <div className="reminder--header modal-message">
        <h3 className="text-center">{translate('reminder.select')}</h3>
        <span className="reminder--grey text-center reminder--subheader">
          {translate('reminder.yourself')}
        </span>
      </div>
      { getAvalibleItem().map(item => (
          <Company
            appCompany={item}
            selectedApp={selectedApp}
            _setSelectedApp={_setSelectedApp}
            translate={translate}
            key={item.id}
          />
        )
      )}
      <div className="reminder--footer">
        <div className="button-box">
          <button className="btn btn-warning btn-remind" onClick={() => { _createReminder(); }}>

            {translate('reminder.remind_send')}
          </button>
        </div>
        <MaxLimitSends hasOutOfLimit={hasOutOfLimit} translate={translate} />
        <div className="generic-text">
          {translate('reminder.hint')}
        </div>
      </div>
    </div>
  );
};

export default Companies;



// WEBPACK FOOTER //
// ./src/components/main/InsuranceInquiry/reminder/companies.js